export default __webpack_public_path__ + "static/drogasil-1da1aef897f95aa77f69ff01dc7b54cb.jpg";